const article = {
    id: 'product-variant-fields',
    title: 'Product variant fields',
    summary: 'Set which product variant fields a client uses, from the client list.',
    publishedAt: '2026-08-17',
    tags: ['clients', 'sku'],
    sections: [
        {
            type: 'paragraph',
            text: 'Product variant fields are configured per client. The setting lives on the client row, next to the other client actions.',
        },
        { type: 'heading', text: 'When to use' },
        {
            type: 'paragraph',
            text: 'Use it when a client’s SKUs need a different set of variant fields than the default.',
        },
        { type: 'heading', text: 'How to use' },
        {
            type: 'steps',
            items: [
                'Open Client.',
                'On the client row, click Product Variant Field.',
                'Choose the fields for that client and save.',
            ],
        },
    ],
};

export default article;
